import React from 'react';
import styled from 'styled-components';
import {
  VkIcon,
  Odnoklassniki,
  YandexIcon,
  GithubIcon,
  TinkoffIcon,
  AppleIcon,
} from '@lt/components/icons-react/auth';
import type { SocialNetworkNames } from 'src/components/AuthNew/utils/socialNetworkUtils';

interface Props {
  className?: string;
  disabled: boolean;
  loginSocialNetwork: (data: SocialNetworkNames) => void;
}

export const SocialAuth: React.FC<Props> = ({
  className,
  loginSocialNetwork,
  disabled,
}) => (
  <SocialContainer className={className}>
    <SocialItem
      type="button"
      disabled={disabled}
      onClick={() => loginSocialNetwork('vk')}
    >
      <VkIcon width={33} height={33} />
    </SocialItem>
    <SocialItem
      type="button"
      disabled={disabled}
      onClick={() => loginSocialNetwork('yandex')}
    >
      <YandexIcon width={33} height={33} />
    </SocialItem>
    <SocialItem type="button" onClick={() => loginSocialNetwork('ok')}>
      <Odnoklassniki width={33} height={33} />
    </SocialItem>
    <SocialItem
      type="button"
      disabled={disabled}
      onClick={() => loginSocialNetwork('apple')}
    >
      <AppleIcon width={33} height={33} />
    </SocialItem>
    <SocialItem
      type="button"
      disabled={disabled}
      onClick={() => loginSocialNetwork('github')}
    >
      <GithubIcon width={33} height={33} />
    </SocialItem>
    <SocialItem
      type="button"
      disabled={disabled}
      onClick={() => loginSocialNetwork('tinkoff')}
    >
      <TinkoffIcon width={33} height={33} />
    </SocialItem>
    {/* временно скрыли тк в РФ не работает facebook */}
    {/* <SocialItem */}
    {/*   type="button" */}
    {/*   disabled={disabled} */}
    {/*   onClick={() => loginSocialNetwork('fb')} */}
    {/* > */}
    {/*   <FbIcon /> */}
    {/* </SocialItem> */}
  </SocialContainer>
);

const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 26px 0 4px;
`;

const SocialItem = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0 8px;
  cursor: pointer;
  display: flex;
  &:disabled {
    opacity: 0.6;
  }
`;
